import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Collapse, Divider, List, ListItemButton, ListItemSecondaryAction, ListItemText } from '@mui/material'
import React, { useState } from 'react'

const SubRubro = (props) => {
    const { setDrawerOpen, setCategorias, rubro, categorias, label } = props
    const [collapseOpen, setCollapseOpen] = useState(false)

    return (
        <>
            <List component="div" disablePadding >
                <ListItemButton onClick={() => { setDrawerOpen(false); setCategorias(label, rubro, "") }} key={rubro.rubroDescription} sx={{ pl: 5 }}>
                    <ListItemText primary={rubro} />
                </ListItemButton>
                <ListItemSecondaryAction>
                    <ListItemButton onClick={() => setCollapseOpen(!collapseOpen)} key={rubro.rubroDescription} sx={{ pl: 2 }}>
                        {collapseOpen ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                </ListItemSecondaryAction>
            </List>
            <Divider />
            <Collapse in={collapseOpen} timeout="auto" unmountOnExit>
                {
                    categorias[label][rubro].map(item => (
                        <List key={`${item.subRubroDescription}-${item.rubroId}`} component="div" disablePadding >
                            <ListItemButton onClick={() => { setDrawerOpen(false); setCategorias(label, rubro, item.subRubroDescription) }} sx={{ pl: 8 }}>
                                <ListItemText primary={item.subRubroDescription} />
                            </ListItemButton>
                        </List>
                    ))
                }
            </Collapse>
        </>
    )
}

export default SubRubro